var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlignright(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7005 0.961792H5.62384C5.55219 0.961792 5.49357 1.02454 5.49357 1.10124V2.07739C5.49357 2.15408 5.55219 2.21684 5.62384 2.21684H13.7005C13.7722 2.21684 13.8308 2.15408 13.8308 2.07739V1.10124C13.8308 1.02454 13.7722 0.961792 13.7005 0.961792ZM13.7005 8.3526H5.62384C5.55219 8.3526 5.49357 8.41535 5.49357 8.49205V9.4682C5.49357 9.54489 5.55219 9.60765 5.62384 9.60765H13.7005C13.7722 9.60765 13.8308 9.54489 13.8308 9.4682V8.49205C13.8308 8.41535 13.7722 8.3526 13.7005 8.3526ZM13.7005 12.048H0.934163C0.862515 12.048 0.803894 12.1108 0.803894 12.1875V13.1636C0.803894 13.2403 0.862515 13.3031 0.934163 13.3031H13.7005C13.7722 13.3031 13.8308 13.2403 13.8308 13.1636V12.1875C13.8308 12.1108 13.7722 12.048 13.7005 12.048ZM13.7005 4.6572H0.934163C0.862515 4.6572 0.803894 4.71995 0.803894 4.79665V5.77279C0.803894 5.84949 0.862515 5.91224 0.934163 5.91224H13.7005C13.7722 5.91224 13.8308 5.84949 13.8308 5.77279V4.79665C13.8308 4.71995 13.7722 4.6572 13.7005 4.6572Z",
    fill: "black",
    fillOpacity: 0.85
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignright);
export default __webpack_public_path__ + "static/media/alignright.067dd23ae3999dcb4b49543757ba6dc3.svg";
export { ForwardRef as ReactComponent };